import dayjs from './DayjsUtil'
import { AppConstantes } from './Constantes'
import { Dispatch } from '@reduxjs/toolkit'
import { PaginaState } from '../models'
import { eliminarFiltroPorClave, establecerOrdenamiento } from '../redux/slices/pagina'

/**
 * @description Retorna un arreglo de los filtros aplicados en el formulario y les asigna una
 *              clave, valor,descripcion,etiqueta y rango (opcional) dependiendo el tipo de
 *              entrada que se maneje: text,fecha,select.
 *
 * @author ana.carrasco  Hábil MX
 * @version 1.0.0, 09/12/2022
 * @param datosEntradaForm Objeto formado las entradas y su tipo.
 * @param filtrosBusqueda  Objeto formado por los nombres de las entradas y sus atributos.
 * @param TFormInputs      Type con el nombre de las entradas y su tipo
 * @returns Retorna un arreglo de filtros con su valor, clave, descripcion, etiqueta, Rango?, isRango?
 */
export function generarArregloFiltrosAplicados<T>(
  datosEntradaForm: {},
  filtrosBusqueda: any,
  TFormInputs: T
) {

  const filtros: any = []
  Object.entries(datosEntradaForm).forEach((filtro: any) => {
    if (
      filtro[1] &&
      filtrosBusqueda[filtro[0] as keyof typeof TFormInputs].tipo !== null &&
      filtro[1][0] !== null
    ) {
      const filtroBusqueda = filtrosBusqueda[filtro[0] as keyof typeof TFormInputs]
      const clave = filtro[0]
      let valor: string[] = []
      const valorAux = filtro[1]
      let descripcion = null
      const etiqueta = filtroBusqueda.etiqueta
      let isRango = filtroBusqueda.isRango
      let rango: string[] = []

      if (filtroBusqueda.tipo === AppConstantes.FILTRO_TEXT) {
        valor = [valorAux]
        descripcion = valorAux
      }

      if (filtroBusqueda.tipo === AppConstantes.FILTRO_FECHA) {
        descripcion = `${dayjs(valorAux[0]).format(AppConstantes.FORMATO_FECHA)} - ${dayjs(
          valorAux[1]
        ).format(AppConstantes.FORMATO_FECHA)}`

        if (filtroBusqueda.isRango) {
          valor = [
            `${dayjs(valorAux[0]).format(AppConstantes.FORMATO_FECHA_GET)}`,
            `${dayjs(valorAux[1]).format(AppConstantes.FORMATO_FECHA_GET)}`,
          ]
          isRango = filtroBusqueda.isRango
          rango = filtroBusqueda.rango
        } else {
          valor = valorAux.valor
        }
      }
      if (filtroBusqueda.tipo === AppConstantes.FILTRO_SELECT) {
        valor = [valorAux.valor]
        descripcion = valorAux.etiqueta
      }
      filtros.push({
        clave,
        etiqueta,
        valor,
        descripcion,
        isRango,
        rango,
      })
    }
  })
  return filtros
}
/**
 * @description Función para ordenar los registros por columna
 *
 * @author andres.martinez, Hábil MX
 * @version 1.0.0, 27/02/2023
 * @param columna nombre de columna que se va a ordenar
 * @param filtrosPagina filtros de pagina
 * @param dispatch función dispatch
 */
export const ordenar = (columna: string, filtrosPagina: PaginaState, dispatch: Dispatch) => {
  if (filtrosPagina.ordenamiento.columna === columna) {
    dispatch(
      establecerOrdenamiento({
        columna,
        ordenar: filtrosPagina.ordenamiento.ordenar === 'asc' ? 'desc' : 'asc',
      })
    )
  } else {
    dispatch(
      establecerOrdenamiento({
        columna,
        ordenar: 'asc',
      })
    )
  }
}

/**
 * @description Función para elimar filtro aplicado
 *
 * @author andres.martinez, Hábil MX
 * @version 1.0.0, 27/02/2023
 * @param claveFiltro
 * @param dispatch Clave del filtro a eliminar
 */
export const eliminarFiltro = (claveFiltro: string, dispatch: Dispatch) => {
  dispatch(eliminarFiltroPorClave(claveFiltro))
}
